import Chartkick from 'chartkick';
import Chart from 'chart.js/auto';

Chartkick.use(Chart);
window.Chartkick = Chartkick;
